
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteA as ObiOwnShipRemoteAElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-a.js';
 
 
 

 
 export const ObiOwnShipRemoteA = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-a',
   elementClass: ObiOwnShipRemoteAElement,
   events: {
     
   }
  });
 
 